import { useEffect, useState } from "react";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, SectionHeading } from "./Section";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Journal = () => {
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/journal").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <section id="journal" className="relative py-28 md:py-36" data-testid="journal-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading index="10" eyebrow="Journal" title="Ideas, journeys & conversations." subtitle="Notes on entrepreneurship, building companies, aviation, agriculture, healthcare, international business — and the lessons in between." />
        <div className="grid gap-5 md:grid-cols-3">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <button onClick={() => setOpen(p)} className="group flex h-full w-full flex-col rounded-2xl border border-white/8 bg-[#10141d] p-7 text-left hover:border-[#E2C08D]/30 hover:bg-[#141926] transition-colors duration-500" data-testid={`journal-card-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="rounded-full border border-[#E2C08D]/25 bg-[#E2C08D]/8 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#E2C08D]">{p.category}</span>
                  <ArrowUpRight size={16} className="text-slate-600 transition-all duration-300 group-hover:text-[#E2C08D] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
                <h3 className="mt-5 font-display text-2xl font-semibold leading-snug text-slate-100">{p.title}</h3>
                <p className="mt-3 flex-1 text-sm text-slate-400 leading-relaxed line-clamp-3">{p.excerpt}</p>
                <div className="mt-6 flex items-center gap-2 font-mono text-[11px] text-slate-500">
                  <BookOpen size={12} /> {p.read_time}
                </div>
              </button>
            </Reveal>
          ))}
        </div>
        {posts.length === 0 && <p className="text-sm text-slate-500" data-testid="journal-empty">New writing will appear here soon.</p>}
      </div>

      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-2xl bg-[#0D1118] border-white/10 text-slate-200 max-h-[85vh] overflow-y-auto" data-testid="journal-dialog">
          {open && (
            <>
              <DialogHeader>
                <span className="w-fit rounded-full border border-[#E2C08D]/25 bg-[#E2C08D]/8 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#E2C08D]">{open.category}</span>
                <DialogTitle className="font-display text-3xl font-semibold text-slate-100 leading-snug pt-3">{open.title}</DialogTitle>
              </DialogHeader>
              <div className="mt-2 space-y-5">
                {open.content.split("\n").filter(Boolean).map((para, i) => (
                  <p key={i} className="text-base text-slate-300 leading-relaxed">{para}</p>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Journal;
